
	(function() {
        var hidden = "hidden";
        var oldtitle = document.title;
        var currenttitle;

        // Standards based on browsers:
        if (hidden in document)
            document.addEventListener("visibilitychange", onchange);
        else if ((hidden = "mozHidden") in document)
            document.addEventListener("mozvisibilitychange", onchange);
        else if ((hidden = "webkitHidden") in document)
            document.addEventListener("webkitvisibilitychange", onchange);
        else if ((hidden = "msHidden") in document)
            document.addEventListener("msvisibilitychange", onchange);
        // IE 9 and lower:
        else if ("onfocusin" in document)
            document.onfocusin = document.onfocusout = onchange;
        // All others:
        else
            window.onpageshow = window.onpagehide
                = window.onfocus = window.onblur = onchange;


        var t1 = '';
       //if tab change happens set status to either hidden or visible
        function onchange (evt) {
            var v = "visible", h = "hidden",
                evtMap = {   //check events and set status based on event type
                    focus:v, focusin:v, pageshow:v, blur:h, focusout:h, pagehide:h
                };

            evt = evt || window.event;
            if (evt.type in evtMap) {  // check the title
                currenttitle = oldtitle;
                $(document).attr('title', currenttitle);
              
              	interTitle(currenttitle,oldtitle);
            }
            else { // We are in hidden state so create unique title
             
                currenttitle = this[hidden] ? " 🔥Don't Forget This... " : oldtitle; //update to whatever you want
                $(document).attr('title', currenttitle);
              	
              	interTitle(currenttitle,oldtitle);
              
            }

        }
      
      	//定时器
        function interTitle(currenttitle,oldtitle){
            var i = 1;

            if(currenttitle != oldtitle){

                t1 = window.setInterval(function(){
                    i % 2 == 0 ? $(document).attr('title', oldtitle) : $(document).attr('title', currenttitle);
                    i++;

                }, 5000);

            }else{

                window.clearInterval(t1);

                $(document).attr('title', oldtitle);
            }
        }

        // set the initial state (but only if browser supports the Page Visibility API)
        if( document[hidden] !== undefined )
            onchange({type: document[hidden] ? "blur" : "focus"});
    })();
(function($){
   window.scrotoT = function () {
    if ($('body').scrollTop() > 0 || $('html').scrollTop() > 0) {
      $('html, body').animate({
        scrollTop: 0
      }, 250, 'swing');
    }
  };
 $(window).scroll(function () {
   sessionStorage.setItem("offsetTop", $(window).scrollTop());
            if ($(document).scrollTop() > 10) {
                $("#scroll-top-button").removeClass("hide");
            } else {
                $("#scroll-top-button").addClass("hide");
            }
        }).trigger('scroll');
  
  window.onload = function(){
  var offset = sessionStorage.getItem("offsetTop");
  $(document).scrollTop(offset);
};
  
  
  var point = null;
    $(".lazyload__image-wrapper").bind("mousedown touchstart", function (e) {
        if (e.type === "touchstart") {
            point = e.originalEvent.targetTouches[0].clientX;
        } else {
            point = e.clientX;
        }
    });
    $(".lazyload__image-wrapper").bind("mouseup touchend", function (e) {
        var upPoint = null;
        if (e.type === "touchend") {
            upPoint = e.originalEvent.changedTouches[0].clientX;
        } else {
            upPoint = e.clientX;
        }
        var distance = upPoint - point;
        if (Math.abs(distance) > 10) {
            if (distance > 0) {
                if($(this).prev().length >0){
                    $(this).addClass("hide");
                    $(this).prev().removeClass("hide");
                }
            } else if (distance < 0) {
                if($(this).next().length>0){
                    $(this).addClass("hide");
                    $(this).next().removeClass("hide");
                }
            }
        }

    });
})(jQuery)